import './App.css';
import React,{useState, useEffect} from 'react'
import Footer from './components/Footer/Footer';
import Header from './components/Header/Header';
import Home from './components/Home/Home';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import About from './components/About/About';
import { Menu } from './components/menu/Menu';
import { Contact } from './components/Contact/Contact';
import { useLocation } from 'react-router-dom';
import { ProjectLog } from './components/ProjectLog/ProjectLog';
import { NotFound } from './components/NotFound/NotFound';
import { Admin } from './components/Admin/Admin';
import cursorIcon from './asset/cursorIcon.png'
import cursorPointer from './asset/Pointer.png'

const App = ()=> {
  const location = useLocation();

  const [cursor, setCursor] = useState(false)


  useEffect(() => {

    
    const cursor = document.querySelector('.mousePointerIcon');

    document.addEventListener('mousemove', e => {
        cursor.setAttribute("style", "display:block; "+ "top: "+(e.clientY-20)+"px; left: "+(e.clientX - 20)+"px;")
    })
        
    const links = document.getElementsByTagName('a')
    for (const link of links) {
        link.addEventListener('mouseover', e =>{setCursor(true)})
        
        setTimeout(function(){
          link.addEventListener('mouseleave', e =>{setCursor(false)})
        }, 500); 
    }
  }, [])

  return (
      <div className="App">
        <div className="mousePointerIcon">
        {cursor ? <img className='cursorPointer'src={cursorPointer} alt=""/> : <img className='cursor' src={cursorIcon} alt=""/>}
      </div>
      <Header />
      <Routes>
            <Route path='/' element={<Home />} />
            <Route path='about' element={<About />} />
            <Route path='contact' element={<Contact />} />
            <Route path='works' element={<ProjectLog />} />
            <Route path='*' element={<NotFound />} />
            <Route path='admin' element={<Admin />} />
      </Routes>
      {location.pathname !=='/contact' && 
        <>
          <Menu /> 
          <Footer />
        </>
      }
          
      </div>
  );
}

export default App;
